import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { useNavBarTitle } from "../contexts/NavBarTitleContext";

export default function DetailsHeader({
  title,
  onBack,
  onRefresh,
  showBack = true,
  showRefresh = true,
  children,
}) {
  const { set, clear } = useNavBarTitle();
  const onBackRef = useRef(onBack);
  const onRefreshRef = useRef(onRefresh);
  onBackRef.current = onBack;
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    set({
      title,
      onBack: (...args) => onBackRef.current?.(...args),
      onRefresh: (...args) => onRefreshRef.current?.(...args),
      showBack,
      showRefresh,
    });
    return clear;
  }, [title, showBack, showRefresh, set, clear]);

  if (!children) return null;

  return <Box sx={{ mb: 2 }}>{children}</Box>;
}

DetailsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func,
  onRefresh: PropTypes.func,
  showBack: PropTypes.bool,
  showRefresh: PropTypes.bool,
  children: PropTypes.node,
};
